import React from "react";
import {Field, reduxForm} from "redux-form";
import {Textarea} from "../../../Utilits/Fields";

const FormDialogs = (props) => {
    return(
        <form onSubmit={props.handleSubmit} className='dialogs__text-form'>
            <div className="dialogs__form form"><Field component={Textarea} name='dialog'/></div>
            <div className="dialogs__submit-button submit-button"><button>Отправить</button></div>
        </form>
    )
};

export default reduxForm({form: "dialogs"})(FormDialogs)